// Detecta se é mobile pela largura da tela
function isMobileViewport() {
  if (typeof window === "undefined") return false;
  return window.innerWidth <= 768;
}

// Detecta se é tablet pela largura
function isTabletViewport() {
  if (typeof window === "undefined") return false;
  return window.innerWidth > 768 && window.innerWidth <= 1024;
}

// Detecta se é mobile via userAgent
function isMobileUserAgent() {
  if (typeof navigator === "undefined") return false;
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

// Detecta se é tablet via userAgent
function isTabletUserAgent() {
  if (typeof navigator === "undefined") return false;
  return /iPad|Tablet|PlayBook|Silk|Kindle|Nexus 7|Nexus 10/i.test(
    navigator.userAgent
  );
}

// Detecta se é touch screen
export function isTouchDevice() {
  if (typeof window !== "undefined") {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0
    );
  }
  return false;
}

export function isMobile() {
  return isMobileViewport() || isMobileUserAgent();
}

export function isTablet() {
  return isTabletViewport() || isTabletUserAgent();
}

export function getDeviceType() {
  if (isMobile()) return "mobile";
  if (isTablet()) return "tablet";
  return "desktop";
}

// Detecta o tipo de navegador
export function getBrowser(): string {
  if (typeof navigator === "undefined") return "";
  return navigator.userAgent.toLowerCase();
};

export function isFirefox(): boolean {
  return getBrowser().includes("firefox");
};

// Detecta se é mobile IOS
export function isMobileIOS(): boolean {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  return isMobile() && isIOS;
};